import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { Trans } from '@lingui/macro'

import { Alert } from 'components/UI/Alert/Alert'

import { Button } from 'components/UI/Button/Button'

import { Loader } from 'components/UI/Loader/Loader'
import { IdOrdersState } from 'model/dashboardOrders/dOrdersReducer';
import { getTransStatus, ORDERSTATUS } from 'constants/ordersStatus';
import { SelectBox, typeValuesListItem } from 'components/UI/SelectBox/SelectBox';
import { dOrdersEditItemSagaAC } from 'model/dashboardOrders/dOrdersActionCreators';




// Type
export type typePopupEdit = {
    variant?: string,
    setOpenPopup: React.Dispatch<React.SetStateAction<boolean>>
}

// Component
export const PopupChangeStatus: React.FC<typePopupEdit> = ( { variant, setOpenPopup } ) => {

    const dispatch = useDispatch()

    // System
    const dataObject = useSelector(( state: { dOrders: IdOrdersState } ) => state.dOrders.detailItem)
    const filters = useSelector((state: { dOrders: IdOrdersState }) => state.dOrders.filters)
    const pagination = useSelector((state: { dOrders: IdOrdersState }) => state.dOrders.pagination)
    // Form data

    //Edit status SelectBox
    const statusValueList: typeValuesListItem[] = [
        { id: ORDERSTATUS.CREATED, name: getTransStatus(ORDERSTATUS.CREATED) },
        { id: ORDERSTATUS.WAITING_FOR_CUSTOMER, name: getTransStatus(ORDERSTATUS.WAITING_FOR_CUSTOMER) },
        { id: ORDERSTATUS.WAITING_FOR_DELIVERY, name: getTransStatus(ORDERSTATUS.WAITING_FOR_DELIVERY) },
        { id: ORDERSTATUS.DELIVERING, name: getTransStatus(ORDERSTATUS.DELIVERING) },
         ]
    const [ statusValue, setStatusValue ] = useState<string>(dataObject!.status!)

    const [ loader, setLoader ] = useState(false)

    // Validation
    const [ validationObj, setValidationObj ] = useState({
        requiredStatus: true,
    })
    useEffect(() => {
        if (statusValue === null) {
            setValidationObj({ ...validationObj, ...{ requiredStatus: false } })
        } else {
            setValidationObj({ ...validationObj, ...{ requiredStatus: true } })
        }
        // eslint-disable-next-line
    }, [ statusValue ])

    const onSaveHandler = async ( e: React.FormEvent ) => {
        e.preventDefault()
        setLoader(true)

        if (statusValue === dataObject!.status) {
            setOpenPopup(false)
            return
        }

        const dataEditObject = {
            id: dataObject!.id,
            status: statusValue,
        }


      // @ts-ignore
        dispatch(dOrdersEditItemSagaAC(dataEditObject, filters,{
           page: pagination.pageNumber,
           size: pagination.itemsPerPage!
       }))
        setLoader(false)
        setOpenPopup(false)

    }

    return (
        <>
            {dataObject
                ? <>
                    <form className="sm:w-80">

                        <input type="hidden" value={dataObject.id}/>

                        <div className="grid gap-4 ">
                            <div>
                                <SelectBox id="status" variant={variant} label={<Trans>Choose status</Trans>}
                                           valuesList={statusValueList} valueId={statusValue}
                                           setIdValue={setStatusValue}/>
                            </div>


                        </div>

                        <div className="flex gap-4 mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">

                            <Button type="submit"
                                    variant={variant}
                                    disabled={!( validationObj.requiredStatus ) || loader}
                                    label={<Trans>Save</Trans>}
                                    onClick={( e ) => onSaveHandler(e)}
                            />
                            <Button type="button"
                                    variant={variant}
                                    secondary={true}
                                    label={<Trans>Cancel</Trans>}
                                    onClick={() => setOpenPopup(false)}/>

                        </div>
                        {loader ? <Loader variant="support"/> : null}
                    </form>
                </>
                : <Alert type="error" title={<Trans>Have no data.</Trans>}/>
            }
        </>
    )
}
